import * as React from 'react';

function SvgFilterProperty(props) {
  return (
    <svg viewBox="0 0 14 14" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M4.771 11.457c0 .242.195.438.435.438h3.588c.24 0 .434-.196.434-.438v-2.68H4.771v2.68zm7.262-9.352H1.966a.437.437 0 00-.376.657l3.026 5.14h4.769l3.025-5.14a.44.44 0 00-.378-.657z" />
    </svg>
  );
}

export default SvgFilterProperty;
